import { create } from "zustand";
import { FiltersFormT } from "../app/Offers/FiltersForm/filters.schema";
import { YachtsFiltersFormT } from "../app/Offers/EditOffer/YachtsFiltersForm/yachts-filters.schema";
import { OfferYacht } from "../app/Offers/model";
import { Currency } from "../app/Currencies/model";
import { AmenityGroup } from "../app/Amenities/model";

export type OffersStore = {
  filters: FiltersFormT | null;
  setFilters: (filters: FiltersFormT | null) => void;
  yachtsFilters: YachtsFiltersFormT | null;
  setYachtsFilters: (filters: YachtsFiltersFormT | null) => void;
  offerYachts: OfferYacht[];
  setOfferYachts: (yachts: OfferYacht[]) => void;
  currencies: Currency[];
  setCurrencies: (currencies: Currency[]) => void;
  offerCurrencyCode: Currency["code"];
  setOfferCurrencyCode: (code: Currency["code"]) => void;
  amenityGroups: AmenityGroup[];
  setAmenityGroups: (groups: AmenityGroup[]) => void;
};

export const useOffersStore = create<OffersStore>((set) => ({
  filters: { type: ["manual"] },
  setFilters: (filters) => set({ filters }),
  yachtsFilters: {}, // { apiStatus: ["synced"] }, TO BE UNCOMMENTED
  setYachtsFilters: (filters) => {
    return set({ yachtsFilters: filters });
  },
  offerYachts: [],
  setOfferYachts: (offerYachts) => set({ offerYachts: offerYachts }),
  currencies: [],
  setCurrencies: (currencies) => set({ currencies }),
  offerCurrencyCode: "",
  setOfferCurrencyCode: (code) => set({ offerCurrencyCode: code }),
  amenityGroups: [],
  setAmenityGroups: (groups) => set({ amenityGroups: groups }),
}));
